import { render, staticRenderFns } from "./CulvertInfoCard.vue?vue&type=template&id=b952a706&scoped=true"
import script from "./CulvertInfoCard.vue?vue&type=script&lang=ts"
export * from "./CulvertInfoCard.vue?vue&type=script&lang=ts"
import style0 from "./CulvertInfoCard.vue?vue&type=style&index=0&id=b952a706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b952a706",
  null
  
)

export default component.exports